import Title from './title';
import Count from './count';
import s from './styles.module.scss';

import type { InteractiveTimeCountData } from 'infrastructure/hooks/interactiveTimeDashboard/types';
import type { FC } from 'react';

interface Props {
  count: InteractiveTimeCountData;
}

const InteractiveTimeDashboardHeader: FC<Props> = ({ count }) => {
  return (
    <div className={s.wrapper}>
      <Title />
      <Count count={count} />
    </div>
  );
};

export default InteractiveTimeDashboardHeader;
